import { type GetSearchResultsPageByUrlQuery } from '@/generated/graphql-types'
import { type SearchActionsResult } from '@/hooks/srp/useSearchActions'
import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'
import { type AppliedFilters } from '@/types/search'
import { sendToLogger } from '@/utils/sendToLogger'

import { getAttributeFromAppliedFilters } from '../getAttributeFromAppliedFilters'

/**
 * Reset a single attribute filter
 */
export const resetAttributeFilter = async ({
  appliedFilters,
  data,
  name,
  refetchResults,
}: {
  appliedFilters: AppliedFilters
  data?: GetSearchResultsPageByUrlQuery['searchResultsPageByUrl']
  name: string
  refetchResults: SearchActionsResult['refetchResults']
}) => {
  const updatedFilters = appliedFilters.filter((item) => item.filterName !== name)

  trackEvent({
    action: GA_EVENT.FilterSelectAttributeAttempt,
    label: `${name}=[]`,
  })

  if (!data) {
    trackEvent({ action: GA_EVENT.FilterSelectFail })
    sendToLogger('"ResetAttributeFilter" called with no data', {
      tags: { component: 'SRP Filters', fn: 'resetAttributeFilter' },
    })
    return
  }

  await refetchResults(data, {
    newAttributeFilters: getAttributeFromAppliedFilters(updatedFilters),
  })
}
